if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      connectedCallback() {
        document.body.classList.add('mobile-sticky-bar-enabled');
        this.classList.add('up');
        this.classList.remove('down');
        this.resizeHandler = this.calculateHeight.bind(this);
        this.calculateHeight();
        window.addEventListener('resize', this.resizeHandler, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }
    }
  );
}
